import { ListContextProvider, useListContext } from '../../list-context/ListContextProvider';
import type { PropsWithChildren } from 'react';
import { ImageListProps } from './@types/StoreImageListProps';
import { getImagesAsJSXList } from './imageAsList';
import { selectedToggleValue } from '../../../redux/canvasResolutionSlice';
import { useSelector } from 'react-redux';

const StoreImageList = ({ images, height = 420, children, preload }: PropsWithChildren<ImageListProps>) => {
	const selectedCanvasResolution = useSelector(selectedToggleValue);
	const list = useListContext()?.list ?? [];
	const isMobile = selectedCanvasResolution <= 1024 ? true : false;

	const blockClass = (children as any)?.[0]?.props.comp.props.blockClass;
	const imageListContent = getImagesAsJSXList(images, isMobile, height, preload, blockClass);
	const newListContextValue = list.concat(imageListContent);

	return <ListContextProvider list={newListContextValue}>{children}</ListContextProvider>;
};

export default StoreImageList;
